import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { GroupCard } from "@/components/groups/GroupCard";
import { JoinForm } from "@/components/groups/JoinForm";
import { CreateGroupDialog } from "@/components/groups/CreateGroupDialog";

const Section = ({ title, testId, empty, groups, onOpen }) => (
  <section className="space-y-2" data-testid={testId}>
    <h3 className="text-[10px] uppercase tracking-wider text-[#6B7280]">{title}</h3>
    {groups.length === 0
      ? <div className="rounded-2xl border border-dashed border-[#27272A] px-4 py-5 text-center text-xs text-[#9CA3AF]">{empty}</div>
      : <div className="space-y-2">{groups.map((g) => <GroupCard key={g.group_id} g={g} onOpen={onOpen} />)}</div>}
  </section>
);

export const CommunityGroups = ({ onClose }) => {
  const navigate = useNavigate();
  const [groups, setGroups] = useState(null);
  const [createOpen, setCreateOpen] = useState(false);
  const load = useCallback(() => api.get("/groups").then((r) => setGroups(r.data)).catch(() => setGroups([])), []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="px-5 py-4 space-y-5">
      <button onClick={() => setCreateOpen(true)} data-testid="group-create-open-btn"
        className="w-full h-10 rounded-full bg-[#2563EB] hover:bg-[#1D4ED8] text-sm font-medium text-white flex items-center justify-center gap-1.5 transition-colors">
        <Plus className="h-4 w-4" /> Create group
      </button>
      <JoinForm onJoined={load} />
      {!groups ? <div className="py-10 flex justify-center"><Loader2 className="h-5 w-5 animate-spin text-[#6B7280]" /></div> : (
        <>
          <Section title="Groups I own" testId="community-groups-owned" empty="You haven't created a group yet."
            groups={groups.filter((g) => g.is_admin)} onOpen={onClose} />
          <Section title="Groups I'm in" testId="community-groups-joined" empty="Browse groups in the Marketplace and request to join."
            groups={groups.filter((g) => !g.is_admin)} onOpen={onClose} />
        </>
      )}
      <CreateGroupDialog open={createOpen} onOpenChange={setCreateOpen} onCreated={(g) => { onClose(); navigate(`/groups/${g.group_id}`); }} />
    </div>
  );
};
